import { render, staticRenderFns } from "./EditArticle.vue?vue&type=template&id=61735eb4&scoped=true"
import script from "./EditArticle.vue?vue&type=script&lang=js"
export * from "./EditArticle.vue?vue&type=script&lang=js"
import style0 from "./EditArticle.vue?vue&type=style&index=0&id=61735eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61735eb4",
  null
  
)

export default component.exports